import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { GoogleMap } from '@angular/google-maps';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as moment from 'moment';
import { AuthService } from 'src/app/components/auth/service/auth.service';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { AddonService } from 'src/app/services/core/addons/addon.service';
import { AppointmentTypeService } from 'src/app/services/core/appointment-type/appointment-type.service';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
import { ServiceAreasService } from 'src/app/services/core/service-areas-service/service-areas.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { timeZone } from 'src/app/utils/utils.common';
import { environment } from 'src/environments/environment';
@UntilDestroy()

@Component({
  selector: 'app-trip-detail-modal',
  templateUrl: './trip-detail-modal.component.html',
  styleUrls: ['./trip-detail-modal.component.css']
})
export class TripDetailModalComponent implements OnInit {
  @Output() closeModal = new EventEmitter<any>
  @Input() tripId: any;
  tripDetail: any;
  appointmentType: any
  member: any;
  preSpacetypes: any = {};
  spacetypes: any;
  @ViewChild('map') map!: GoogleMap;
  events: any = [];
  fundingSource: any;
  preCompanies: any;
  serviceAreas: any;
  preServiceAreas: any;
  addons: any;
  preAddons: any;
  user: any;
  timeZone: any = timeZone;
  todayDate: any;
  driver:any;
  vehicle:any;
  serviceAreaList:any = [];
  prespacetypes: any;
  preFundingSource: any;
  routeVisible = false;
  directions?: google.maps.DirectionsResult;
  straightPath: google.maps.LatLngLiteral[] = [];
  trackinURL:any;
  constructor(
    private appointmentTypeService: AppointmentTypeService,
    private spaceTypeService: SpaceTypeService,
    private authService: AuthService,
    private fundingSourceService: FundingSourceService,
    private companyService: CompanyService,
    private serviceArea:ServiceAreasService,
    private addonService: AddonService,
    private credentialService: CredentialService,
    private tripService: TripService,
  private sharedDataService: SharedDataService) {
   }

  ngOnInit(): void {
    this.getUser()
    this.getTripById();
    this.trackinURL = environment.TRACKING_URL;

  }

  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.user = data;
        if (this.user.timezone) {
          this.timeZone = this.user.timezone;
        }
        this.todayDate = [
          moment().tz(this.timeZone).startOf('day'),
          moment().tz(this.timeZone).endOf('day')
        ];
      }

    })
  }

  ngAfterViewInit(): void {
    this.fitMapToBounds();
  }

  formatValue(value: any) {

    if (typeof value === 'number') {
      return value.toFixed(2);
    } else if (typeof value === 'object' && value !== null) {
      return `Rate: ${value.fare ?? 'N/A'} From: ${value.from ?? ''} To: ${value.to ?? ''}`;
    } else {
      return 'N/A';
    }
  }
 

  getTripById() {
    const queryParams = {
      source: 'memberPanel'
    }
    this.tripService.getTripById(this.tripId, queryParams).pipe(untilDestroyed(this)).subscribe((data) => {
        if (data) {
          this.tripDetail = data
          if (this.tripDetail?.pickup && this.tripDetail?.destination) {

            this.straightPath = [
              {
                lat: this.tripDetail.pickup.address.coords[1],
                lng: this.tripDetail.pickup.address.coords[0]
              },
              {
                lat: this.tripDetail.destination.address.coords[1],
                lng: this.tripDetail.destination.address.coords[0]
              }
            ];
          }
          this.getAppointmentById();
          this.getTripEvents();
          // this.getSpaceTypes();
          // this.getFundingSource();
          this.getServiceArea();
          this.getSpaceType();
          this.getFundingSource()
          this.getAllAddons()
          this.getDriverById();
          this.getVehicleById();
          setTimeout(() => this.fitMapToBounds(), 0);
        
        }
      })
  }

  // getSortedBreakdown(fare: any,breakdown: any) {
  //   if (!breakdown) return [];

  //   const priority: Record<string, number> = {
  //     total: 0,
  //     baseFare: 1,
  //   };
  //   return Object.entries(breakdown)
  //     .sort(([keyA], [keyB]) => {
  //       const orderA = keyA in priority ? priority[keyA] : 2;
  //       const orderB = keyB in priority ? priority[keyB] : 2;
  //       return orderA - orderB;
  //     })
  //     .map(([key, value]) => ({
  //       key: this.formatKey(key),
  //       value
  //     }));
  // }

   private getUnit(key: string, value: any, fare: any): string {
    const lowerKey = key.toLowerCase();
    if(value === null){
      return ''
    }
    // Explicit overrides
    const unitMap: Record<string, string> = {
      distance: 'mi',
      duration: 'min',
    };

    if (unitMap[lowerKey]) return unitMap[lowerKey];

    // If it's numeric and not distance/duration, assume currency
    const moneyLikeKeys = [
      'basefare',
      'permilefare',
      'perminfare',
      'total',
      'waittimecharges',
      'pickupsurcharge',
      'extrapassengerfare',
      'additionalpassengers',
      'cancelcharges',
      'noshowcharges',
    ];
    if (moneyLikeKeys.includes(lowerKey)) return '$';

    // Otherwise fallback to type
    if (fare?.type === 'percentage') return '%';
    if (fare?.type === 'fixed') return '$';

    return '';
  }

   getSortedBreakdown(fare: any, breakdown: any) {
    if (!breakdown) return [];

    const priority: Record<string, number> = {
      total: 0,
      baseFare: 1,
    };

    return Object.entries(breakdown)
      .sort(([keyA], [keyB]) => {
        const orderA = keyA in priority ? priority[keyA] : 2;
        const orderB = keyB in priority ? priority[keyB] : 2;
        return orderA - orderB;
      })
      .map(([key, value]) => ({
        key: this.formatKey(key),
        value,
        unit: this.getUnit(key, value, fare) // pass the parent fare object
      }));
  }
  private formatKey(key: string): string {
    return key
      .replace(/([A-Z])/g, ' $1')           // insert space before capital letters
    .replace(/^./, char => char.toUpperCase()); // capitalize first letter
  }

  fitMapToBounds() {
    const pickup = this.tripDetail?.pickup?.address?.coords;
    const dropoff = this.tripDetail?.destination?.address?.coords;

    if (!pickup || !dropoff || !this.map || !this.map.googleMap) return;

    const bounds = new google.maps.LatLngBounds();
    bounds.extend(new google.maps.LatLng(pickup[1], pickup[0]));
    bounds.extend(new google.maps.LatLng(dropoff[1], dropoff[0]));

    const gMap = this.map.googleMap;
    if (!gMap) return;

    gMap.fitBounds(bounds, 8);
    const mzoom: any = gMap.getZoom();
    gMap.setZoom(mzoom)
  }

  getServiceArea() {
    this.serviceArea.getPicker({ isActive: true, limit:9999 }).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results && data.results.length) {
        this.serviceAreaList = data.results;
          this.preServiceAreas = this.serviceAreaList.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }

   getSpaceType() {
    let queryParams = {
      isActive: true,
      limit: 9999,
    }
    this.spaceTypeService.getPicker(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results ) {
        this.spacetypes = data.results;
        this.prespacetypes = this.spacetypes.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }


  getTripEvents() {
     if(this.tripDetail.status === 'scheduled') return;
     const queryParams:any = {
      trip: this.tripId
    };
    this.tripService.getTripEvents(queryParams).pipe(untilDestroyed(this)).subscribe((data:any) => {
         if (data && data.results) {
            this.events = data.results;
        }
      })
  }

  getDriverById() {
    if(!this.tripDetail?.driver) return
    this.credentialService.getDriverById(this.tripDetail.driver).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.driver = data;
      }
    })
  }

  getVehicleById() {
    if(!this.tripDetail?.vehicle) return
    this.credentialService.getVehicleById(this.tripDetail.vehicle).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.vehicle = data;
      }
    })
  }


  getAppointmentById() {
    this.appointmentTypeService.getPicker().pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
          this.appointmentType = data.results.find((item: any) => item.id === this.tripDetail.appointmentType);
        }
      })
  }

  getSpaceTypes() {
    this.spaceTypeService.getById(this.tripDetail.spaceType).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.spacetypes = data;
      }
    })
  }

   getFundingSource() {
    this.fundingSourceService.getPicker({ isActive: true, limit:9999 }).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results && data.results.length) {
        this.fundingSource = data.results;
        this.preFundingSource = this.fundingSource.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        console.log(this.preFundingSource);
      }
    })
  }

  getAllAddons() {
    const queryparams = {
      limit: 9999,
      isActive: true
    }
    this.addonService.getPickerAddons(queryparams).pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data.results) {
          this.addons = data.results;
        this.preAddons = this.addons.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      })
  }

  loadDirections() {
    if (!this.tripDetail?.pickup || !this.tripDetail?.destination) return;

    const pickup = this.tripDetail.pickup.address.coords;
    const dropoff = this.tripDetail.destination.address.coords;

    const service = new google.maps.DirectionsService();

    service.route(
      {
        origin: { lat: pickup[1], lng: pickup[0] },
        destination: { lat: dropoff[1], lng: dropoff[0] },
        travelMode: google.maps.TravelMode.DRIVING,
        provideRouteAlternatives: true // get multiple routes
      },
      (result: any, status) => {
        if (status === 'OK' && this.routeVisible) {
          // 🔹 Pick the shortest route
          let shortestRoute = result.routes[0];
          let minDistance = result.routes[0].legs.reduce(
            (sum: number, leg: any) => sum + leg.distance.value,
            0
          );

          result.routes.forEach((route: any) => {
            const routeDistance = route.legs.reduce(
              (sum: number, leg: any) => sum + leg.distance.value,
              0
            );
            if (routeDistance < minDistance) {
              minDistance = routeDistance;
              shortestRoute = route;
            }
          });

          // Only assign the shortest route
          this.directions = {
            ...result,
            routes: [shortestRoute],
          };
        }
      }
    );
  }

 toggleRoute(checked: boolean) {
  this.routeVisible = checked;  // Set based on event
  if (this.routeVisible) {
    if (!this.directions) {
      this.loadDirections();
    }
  } else {
    this.fitMapToBounds();
  }
}
  
  onCloseModal() {
    this.closeModal.emit();
  }
}
